"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const selectors_1 = require("@/store/ducks/systemComponents/selectors");
const style_1 = require("./style");
function AssociateSystemComponentsTitle() {
    const systemName = (0, react_redux_1.useSelector)(selectors_1.selectedSystemNameSelector);
    return (react_1.default.createElement(style_1.ValueWrapper, null,
        react_1.default.createElement(style_1.UntoggledValue, { variant: "h1" }, systemName),
        " "));
}
exports.default = AssociateSystemComponentsTitle;
